import { NgModule } from '@angular/core';
import { NgIf } from '@angular/common';
import { CoreRoutingModule } from './core-routing.module';
import { CoreMainTemplateComponent } from './templates/core-main-template/core-main-template.component';
import { StoreModule } from '@ngrx/store';
import { coreReducer, featureName } from './store/core.reducer';
import { SdButtonsModule } from '../shared/sd-buttons/sd-buttons.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AccountModule } from '../account/account.module';
import { DictionaryModule } from '../dictionary/dictionary.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SdAlertsModule } from '../shared/sd-alerts/sd-alerts.module';
import { SdFormsModule } from '../shared/sd-forms/sd-forms.module';
import { BrandingService } from '../branding/services/branding.service';
import { BulkUploadService } from '../bulk-upload/services/bulk-upload.service';
import { AssetsService } from '../files/services/assets.service';
import { AccountService } from '../account/services/account.service';
import { FilesService } from '../files/services/files.service';
import { FilesBulkDeliveryService } from '../files-bulk-delivery/services/files-bulk-delivery.service';
import { IntegrationsService } from '../integrations/services/integrations.service';
import { MessagesService } from '../messages/services/messages.service';
import { NetworksService } from '../networks/services/networks.service';
import { PaymentMethodsService } from '../payment-methods/services/payment-methods.service';
import { PlansService } from '../plans/services/plans.service';
import { PricesService } from '../prices/services/prices.service';
import { RecordTypesService } from '../record-types/services/record-types.service';
import { RecordsService } from '../records/services/records.service';
import { XlsxService } from '../shared/services/xlsx.service';
import { SideDrawersService } from '../sidedrawers/services/side-drawers.service';
import { SubscriptionsService } from '../subscriptions/services/subscriptions.service';
import { TeamsService } from '../teams/services/teams.service';
import { TemplatesService } from '../templates/services/templates.service';
import { UsersService } from '../users/services/users.service';
import { InvitationsService } from '../invitations/services/invitations.service';
import { DragDropOverlaySnackBarContainer } from '../files/directives/drag-and-drop/directive/drag-and-drop/drag-drop-overlay-container';
import { SdConfirmSuccessErrorDialogService } from '../shared/sd-confirm-success-error-dialog/services/sd-confirm-success-error-dialog.service';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { VaultsService } from '../vaults/services/vaults.service';
import { VaultsGlobalStore } from '../vaults/store/vaults-global.store';
import { VaultDrawersGlobalStore } from '../vaults/store/vault-drawers-global.store';
import { DragAndDropModule } from '../files/directives/drag-and-drop/drag-and-drop.module';
import { TagsService } from '../tags/services/tags.service';
import { TagsGlobalStore } from '../tags/store/tags-global.store';
import { SdIframeForIntegrationSignalStore } from '../shared/sd-iframe-for-integration-a11y/store/sd-iframe-for-integration-signal.store';
import { InvitationsGlobalStore } from '../invitations/store/invitations-global.store';
import { SdCommentsTenantService } from '../comments/services/sd-comments-tenant.service';
import { FormRequestsGlobalStore } from '../plans/store/form-requests-global.store';
import { EffectsModule } from '@ngrx/effects';
import { CoreEffects } from './store/core.effects';
import { StatusFlagsService } from '../status-flags/services/status-flags.service';
import { StatusFlagsGlobalStore } from '../status-flags/store/status-flags-global.store';
import { SdDialogConfirmModule } from '../shared/sd-dialog-confirm/sd-dialog-confirm.module';

@NgModule({
  declarations: [CoreMainTemplateComponent],
  imports: [
    CoreRoutingModule,
    StoreModule.forFeature(featureName, coreReducer),
    EffectsModule.forFeature([CoreEffects]),
    AccountModule,
    DictionaryModule,
    SdButtonsModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    SdAlertsModule,
    SdFormsModule,
    MatProgressBarModule,
    NgIf,
    DragAndDropModule,
    SdDialogConfirmModule,
  ],
  providers: [
    AccountService,
    BrandingService,
    BulkUploadService,
    AssetsService,
    FilesService,
    FilesBulkDeliveryService,
    IntegrationsService,
    MessagesService,
    NetworksService,
    PaymentMethodsService,
    PlansService,
    PricesService,
    RecordTypesService,
    RecordsService,
    XlsxService,
    SideDrawersService,
    SubscriptionsService,
    TeamsService,
    TemplatesService,
    UsersService,
    InvitationsService,
    DragDropOverlaySnackBarContainer,
    SdConfirmSuccessErrorDialogService,
    StatusFlagsService,
    StatusFlagsGlobalStore,
    VaultsService,
    VaultsGlobalStore,
    VaultDrawersGlobalStore,
    TagsService,
    TagsGlobalStore,
    SdIframeForIntegrationSignalStore,
    InvitationsGlobalStore,
    SdCommentsTenantService,
    FormRequestsGlobalStore,
  ],
})
export class CoreModule {}
